import React from "react";
import { onlyNumberdesimal, onlyLetters } from "../../helpers/formats";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { initialValuesForDebitCredit } from "../../components/common/utlity/intialValues";
import { optionsForCustomerOrSupplier } from "../../components/common/utlity/options";
import CustomPhoneNumberField from "../../components/common/customPhone";
import CustomField from "../../components/common/customField";
import { createNote, updatenotes } from "../../services/debitCredit.service";
import { useState } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { AWS_URL } from "../../services/http.service";
import { useNavigate } from "react-router-dom";
import { FiEdit3, FiCreditCard,FiArrowLeft } from "react-icons/fi";
import { getCreditNotesData } from "../../store/actions/action";
import { useDispatch } from "react-redux";

const AddCreditNotes = ({ close, updateCredit, addCredit, item }) => {
  const [itemphoto, setItemphoto] = useState(null);
  const { t } = useTranslation();
  const [creditIsLoading, setCreditIsLoading] = useState(false);
  const { bussinessUuid } = useParams();
  const navigate = useNavigate();
const dispatch = useDispatch();

  const signInSchema = Yup.object().shape({
    amount: Yup.number().required(
      <span className='text-xs dark:text-red-500'>Amount is required</span>
    ),
  });

  const onSubmit = async (values, { resetForm }) => {
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (itemphoto) {
      formData.append("avatar", itemphoto);
    }
    if (item) {
      setCreditIsLoading(true);

      const { noteNumber } = item;
      const result = await updatenotes(bussinessUuid, noteNumber, formData);
      setCreditIsLoading(false);

      if (result.data) {
        updateCredit(result?.data);
        close(true);
        toast.success("Updated Successfully ");
        await dispatch(
                              getCreditNotesData(bussinessUuid, {
                                page: 1,
                                limit: 10,
                                search: "",
                              }),
                            );
        navigate(-1)
      } else {
        toast.error("Something Went  wrong!");
      }
    } else {
      setCreditIsLoading(true);

      const result = await createNote(bussinessUuid, formData);
      setCreditIsLoading(false);

      // console.log("result", result);
      if (result.data) {
        addCredit(result.data);
        toast.success("Added Successfully");
        navigate(-1)
        close(true);
      } else {
        toast.error("Failed to Add");
      }
      console.log("details submitted:", values);
    }
  };
  const handleChangeforFile = (e) => {
    const selectedFile = e.target.files[0];
    setItemphoto(selectedFile);
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValuesForDebitCredit(item ? item : null, true)}
      validationSchema={signInSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        const { errors, values, touched, handleBlur, handleChange } = formik;
        return (
          <Form>
            <div className='container mx-auto'>
              <div className='grid gap-4 grid-cols-1'>
                <div className='p-3 dark:text-white bg-white dark:bg-slate-900 h-[calc(100vh-64px)]'>
                  <div className="mt-1 p-3 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                    <div className="flex items-center gap-4 mt-3 mb-6">
                      <button
                                                                                  type="button"
                                                                                  onClick={() => navigate(-1)}
                                                                                  className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
                                                                                >
                                                                                  <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
                                                                                </button>
  <div className="w-14 h-14 rounded-xl bg-green-100 text-green-600 flex items-center justify-center shadow">
    {item ? <FiEdit3 size={28} /> : <FiCreditCard size={28} />}
  </div>

  <div>
    <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
      {item ? t("FORM.UPDATE_CREDIT") : t("FORM.ADD_CREDIT")}
    </h1>

    <p className="text-sm text-gray-500 dark:text-gray-400">
      {item
        ? t("EXTRA.MODIFY_THE_CREDIT")
        : t("EXTRA.ENTER_THE_CREDIT")}
    </p>
  </div>
</div>

                  <div className="grid grid-cols-3 gap-4 w-full mb-4 ">
                    <div className='p-1 col-span-1 mb-2'>
                      <CustomField
                        type='select'
                        name='customerOrSupplier'
                        label={t("FORM.TYPE")}
                        placeholder='Type*'
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        options={optionsForCustomerOrSupplier}
                        value={values.customerOrSupplier}
                        error={errors.customerOrSupplier}
                        touched={touched.customerOrSupplier}
                      />
                    </div>
                    <div className='p-1 col-span-1'>
                      <CustomField
                        type='text'
                        name={"customerName"}
                        label={
                          values.customerOrSupplier === "customer"
                            ? t("CUSTOMER.CUSTOMER_NAME")
                            : t("FORM.SUPPLIER_NAME")
                        }
                        handleChange={handleChange}
                        value={values.customerName}
                        onKeyPress={onlyLetters}
                      />
                    </div>
                    <div className='p-1 col-span-1'>
                      <CustomPhoneNumberField
                        name={"customerMobile"}
                        country={values.countryCode}
                        label={
                          values.customerOrSupplier === "customer"
                            ? t("FORM.CUSTOMER_NUMBER")
                            : t("FORM.SUPPLIER_NUMBER")
                        }
                        placeholder='Mobile'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.customerMobile}
                        error={errors.customerMobile}
                        touched={touched.customerMobile}
                      />
                    </div>
                  </div>
                 <div className="grid grid-cols-3 gap-4 w-full mb-4 ">
                    <div className='col-span-1'>
                      <CustomField
                        type='text'
                        name='gstIn'
                        label={t("FORM.GSTIN")}
                        placeholder='Supplier GST'
                        handleChange={handleChange}
                        value={values.gstIn}
                      />
                    </div>
                    <div className='col-span-1 mb-2'>
                      <CustomField
                        type='text'
                        name='referenceInvoice'
                        label={t("FORM.REFERENCE_INVOICE")}
                        placeholder='Refrence Invoice'
                        handleChange={handleChange}
                        value={values.referenceInvoice}
                      />
                    </div>
                    <div className='col-span-1 mb-2'>
                      <CustomField
                        type='text'
                        name='amount'
                        label={t("FORM.AMOUNT")}
                        placeholder='Amount'
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        onKeyPress={onlyNumberdesimal}
                        value={values.amount}
                        error={errors.amount}
                        touched={touched.amount}
                      />
                    </div>
                    <div className='col-span-1 mb-2'>
                      <CustomField
                        type='date'
                        name='issueDate'
                        label={t("FORM.CREATOR_DATE")}
                        placeholder='Create Date'
                        handleChange={handleChange}
                        value={values.issueDate}
                      />
                    </div>
                    <div className='col-span-1 mb-2'>
                      <CustomField
                        type='text'
                        name='reason'
                        placeholder='Note'
                        label={t("FORM.NOTE")}
                        handleChange={handleChange}
                        value={values.reason}
                      />
                    </div>

                    {values.customerOrSupplier === "supplier" && (
                      <>
                        <div className='col-span-1 mb-2'>
                          <CustomField
                            type='text'
                            name='noteRefrenceNumber'
                            label={t("FORM.NOTE_REFERENCE_NUMBER")}
                            placeholder='Note Refrence Number'
                            handleChange={handleChange}
                            value={values.noteRefrenceNumber}
                          />
                        </div>

                        <div className='col-span-3 mb-2'>
                          {item && item.document ? (
                            <div className='flex'>
                              <div className='w-1/3 mr-1'>
                                <div className='items-center'>
                                  <img
                                    src={AWS_URL + item.document}
                                    alt='item'
                                    className='h-20'
                                  />
                                </div>
                              </div>
                              <div className='w-2/3'>
                                <CustomField
                                  type='file'
                                  name='document'
                                  placeholder='Change Document'
                                  handleChange={handleChangeforFile}
                                  value={
                                    values.itemphoto
                                      ? values.itemphoto.name
                                      : ""
                                  }
                                  uploadFiletext={
                                    itemphoto
                                      ? itemphoto.name
                                      : "Change Document"
                                  }
                                  extraClass='p-7'
                                />
                              </div>
                            </div>
                          ) : (
                            <CustomField
                              type='file'
                              name='document'
                              placeholder='Upload Document'
                              handleChange={handleChangeforFile}
                              value={
                                values.itemphoto ? values.itemphoto.name : ""
                              }
                              uploadFiletext={
                                itemphoto ? itemphoto.name : "Upload Document"
                              }
                              extraClass='p-7'
                            />
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className='flex justify-end'>
                    {item ? (
                      <button
                        type='submit'
                        className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right'
                        disabled={creditIsLoading} // Disable button during loading
                      >
                        {creditIsLoading ? (
                          <BeatLoader
                            size={8}
                            color='#ffffff'
                            loading={creditIsLoading}
                          />
                        ) : (
                          t("FORM.UPDATE_CREDIT")
                        )}
                      </button>
                    ) : (
                      <button
                        type='submit'
                        className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right'
                        disabled={creditIsLoading} // Disable button during loading
                      >
                        {creditIsLoading ? (
                          <BeatLoader
                            size={8}
                            color='#ffffff'
                            loading={creditIsLoading}
                          />
                        ) : (
                          t("FORM.ADD_CREDIT")
                        )}
                      </button>
                    )}
                  </div>
                    </div>
                </div>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default AddCreditNotes;
